import Controller from "../components/simple_select2_input_controller.js"

export default class extends Controller {
  static values = {
    organizationId: Number,
    options: { type: String, default: "{}" },
    locked: Number
  }

  connect() {
    let options = JSON.parse(this.optionsValue)
    let ajax = options.ajax
    const lockedElementId = this.lockedValue
    if(this.organizationIdValue)
      ajax.data = this.queryParams(this.organizationIdValue)
    options = {
      ...this.defaultOptions(),
      ...options,
      ajax: ajax,
      templateSelection: function (data, container) {
        if (data.id == lockedElementId) {
          $(container).addClass("locked-select2-option")
        }
        return data.text
      }
    }

    this.setupSelect2(this.element, options)

    if (!lockedElementId)
      return

    // Prevent removing the locked element
    $(`li[data-select2-id="${lockedElementId}"]`).find(".select2-selection__choice__remove").remove()
    $(this.element).on("select2:unselecting", (e) => {
      if(e.params.args.data.id == lockedElementId)
        e.preventDefault()
    })

    $(this.element).on("change.select2", (e) => {
      const selectedValues = $(this.element).val()
      if(selectedValues.length == 1 && selectedValues[0] == lockedElementId) {
        $(".edit-exclusion-submit").prop("disabled", true)
      }
      else{
        $(".edit-exclusion-submit").prop("disabled", false)
      }
    })
    $(this.element).trigger("change.select2")
  }
  

  queryParams(organizationId) {
    return function (params) {
      let organizationParam = {}

      if (organizationId !== 0)
        organizationParam.organization_id = organizationId

      return {
        ...params,
        ...organizationParam
      }
    }
  }
}
